<kendo-formfield>
    <kendo-label [text]="caption | translate">
        <button class="button-mini" kendoButton (click)="defineNewItem()" look="flat" type="button">
            <kendo-icon [name]="'plus'">                
            </kendo-icon>
          </button>
    </kendo-label>
    <kendo-combobox #listComboCity [ngClass]="{'fx-fill': settings.fxFill}" [data]="valuesList$ | async"
        [textField]="textField" [valueField]="valueField" [valuePrimitive]="true" [formControl]="control"
        [filterable]="true" (valueChange)="onChange($event)" (filterChange)="filterChange($event)">

        <ng-template kendoComboBoxItemTemplate let-listItem>
            <div fxFill class="list-item-display" fxLayout="row">
                {{ listItem[textField] }}
            </div>
        </ng-template>

        <ng-template kendoDropDownListNoDataTemplate>
            <div *ngIf="!(term$|async)">{{'kendo.combobox.startTyping' | translate}}</div>
            <div *ngIf="term$|async">{{'kendo.combobox.noMatch' | translate}}</div>
        </ng-template>
    </kendo-combobox>
</kendo-formfield>
<div kendoDialogContainer #cityDialog></div>